import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
export interface ScoreConfigMst{
      id:number 
      scoreTypeId:number
      scoreName:string 
      scoreIndicatorName:string 
      scoreSortOrder:string 
      indicatorType:string 
      indicatorSubType:string 
      indicatorPos:number 
}

export interface PatientScoreTransDto{
        id:number, 
        scoreTypeId:number,
        totalScore:number,
        grade:string, 
        regId:string, 
        iPId:number, 
        visitId:number, 
        Entry_From:string,  
        templateId:number, 
        userType:string, 
        empId:string, 
        phyId:string, 
        notes:string, 
        tenantId:string, 
        branchId:string, 
        createdDate:Date, 
        createdBy:number, 
        createdIP:string, 
        updatedDate:Date, 
        updatedBy:number, 
        updatedIP:string,
        tableName?:string,
        indicatorSubType?:string, 
        userName?:string
        templateName?:string
        detail:PatientScoreTransDet[]
}

export interface PatientScoreTransDet
{
     id:number, 
     tranMstId:number, 
     scoreTypeId:number, 
     psId:number, 
     score:number, 
     tenantId:string, 
     branchId:string,
     scoreIndicatorName?:string,
     indicatorType?:string, 
     indicatorSubType?:string,
     scoreName?:string,
     patientScore?:PatientScoreTransDet
}
export abstract class PatientScoreConfigData {
    abstract getByName<type>(url:string,queryparams:HttpParams):Observable<type>
    abstract get(url:string,queryparams:HttpParams):Observable<any>
    abstract add(url:string,data:PatientScoreTransDto):Observable<any>
    abstract update(url:string,data:PatientScoreTransDto,queryparams:HttpParams):Observable<any>


}